export const DatagridCollection = {
  add_column: (element) => {
    element.querySelector('button').addEventListener('click', () => {
      var wrapper = element.querySelector('template').content.cloneNode(true);
      element.parentNode.parentNode.insertBefore(wrapper, element.parentNode);
    })
  }
};
